import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ResetPasswordScreen() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async e => {
    e.preventDefault();
    if (newPassword !== confirm) { setError('Hasla nie sa identyczne'); return; }
    if (newPassword.length < 8) { setError('Haslo min. 8 znakow'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Blad serwera'); return; }
      setDone(true);
    } catch { setError('Blad polaczenia z serwerem'); }
    finally { setLoading(false); }
  };

  if (!token) return (
    <div style={{ minHeight: '100vh', background: '#020617', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', color: '#ef4444', fontSize: '0.9rem' }}>Nieprawidlowy link resetu hasla.</div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#020617', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: 400, background: '#0f172a', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: 32 }}>
        <div style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: 24, color: '#fff' }}>
          ISO<span style={{ color: '#2563EB' }}>Forge</span>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>✅</div>
            <p style={{ color: '#94a3b8', marginBottom: 24, lineHeight: 1.6 }}>Haslo zostalo zmienione. Mozesz sie teraz zalogowac.</p>
            <button onClick={() => navigate('/app')}
              style={{ background: '#2563EB', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 24px', fontWeight: 700, cursor: 'pointer', fontSize: '0.9rem' }}>
              Przejdz do logowania
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h2 style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 700, marginBottom: 24 }}>Nowe haslo</h2>
            {error && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: '0.85rem', marginBottom: 16 }}>{error}</div>}
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', marginBottom: 6 }}>Nowe haslo (min. 8 znakow)</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required
                style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 14px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', marginBottom: 6 }}>Powtorz haslo</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                style={{ width: '100%', background: '#1e293b', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 14px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' }} />
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', background: loading ? '#1d4ed8' : '#2563EB', color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontSize: '0.95rem', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Zmieniam haslo...' : 'Zmien haslo'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
